import axios from 'axios'

const localState = {
    show: false,
    user: {},
    currentCall: '',
    answer: false,
    adminTalking: false,
}

const actions = {
    showCallModal({ state }, user) {
        state.show = true
        state.user = user
    },
    hideCallModal({ state }) {
        state.show = false
    },
    initCall({ state, dispatch, commit }, { type, id }) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .post(
                        `calls/${type}/init`,
                        { companion: id },
                        window.requestConfig,
                    )
                    .then((res) => {
                        state.currentCall = res.data.session_id
                        resolve(res.data)
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        } else if (err.response.status === 422) {
                            // dispatch('resetSession');
                            dispatch('hideCallModal')
                        }
                        reject()
                    })
            })
        })
    },
    answerCall({ dispatch, commit }, { type, id }) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .post(
                        `calls/${type}/answer`,
                        { session_id: id },
                        window.requestConfig,
                    )
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
    async rejectCall(_, { type, id }) {
        try {
            const response = await axios.post(
                `calls/${type}/cancel`,
                { session_id: id },
                window.requestConfig,
            )
            return response.data
        } catch (err) {
            // log err
        }
    },
    getIncomingCall({ state, dispatch, commit }) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .get('calls/incoming', window.requestConfig)
                    .then((res) => {
                        if (res.data.calls.length) {
                            state.currentCall = res.data.calls[0].session_id
                            const user = {
                                fullName: res.data.calls[0].name,
                                photo: res.data.calls[0].image,
                                session_id: res.data.calls[0].session_id,
                                type: res.data.calls[0].type,
                                isAnswer: true,
                                isAudioCall: false,
                            }

                            if (state.show === false) {
                                dispatch('showCallModal', user)
                            }
                        }
                        resolve(res.data)
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
}

const mutations = {
    setAdminTalking: (state, v) => {
        state.adminTalking = v
    },
}

const getters = {
    userCallGetters: (state) => state.user,
    adminTalkingGetters: (state) => state.adminTalking,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
